import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/auth';

// 创建认证上下文
const AuthContext = createContext();

// 认证提供者组件
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 初始化认证状态
  useEffect(() => {
    const initializeAuth = () => {
      try {
        const currentUser = authService.getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error('初始化认证状态失败:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  // 登录
  const login = async (credentials) => {
    try {
      const response = await authService.login(credentials);

      if (response.code === 200) {
        // 保存认证信息
        authService.setAuth(response.data, { username: credentials.username });
        setUser({ username: credentials.username });
        return { success: true };
      } else {
        return { success: false, message: response.message || '登录失败' };
      }
    } catch (error) {
      console.error('登录失败:', error);
      return { success: false, message: error.message || '登录失败' };
    }
  };

  // 注册
  const register = async (userData) => {
    try {
      const response = await authService.register(userData);

      if (response.code === 200) {
        return { success: true, message: '注册成功' };
      } else {
        return { success: false, message: response.message || '注册失败' };
      }
    } catch (error) {
      console.error('注册失败:', error);
      return { success: false, message: error.message || '注册失败' };
    }
  };

  // 注销
  const logout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error('注销失败:', error);
    } finally {
      // 清除认证信息
      authService.clearAuth();
      setUser(null);
    }
  };

  // 认证上下文值
  const authContextValue = {
    user,
    login,
    register,
    logout,
    isAuthenticated: !!user,
    loading
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

// 自定义hook用于访问认证上下文
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;